// @flow

import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { localize } from "redux-i18n";

import actionCreators from "@modules/service/actionCreator";
import * as serviceSelectors from "@modules/service/selectors";
import * as sharedSelectors from "@modules/shared/selectors";
import type {
  DynamicQuestionContent,
  AbsenceReason,
} from "@modules/service/reducer/dynamic-questions/types";
import { ReasonSpecificUsageForm } from "../dynamic-question-reason-specific-usage";
import { split } from "@transformers/schema";
import type { StepProps } from "@components";
import { View } from "@components";

type PropsFromState = $Exact<{
  draft: ?DynamicQuestionContent,
  absenceReasons: Array<AbsenceReason>,
  schema: ?Object,
  isValid: boolean,
}>;

type PropsFromDispatch = $Exact<{
  onUpdateDraft: typeof actionCreators.UpdateDynamicQuestionDraft,
}>;

type Props = $Exact<{
  ...StepProps,
  ...PropsFromLocalize,
  ...PropsFromState,
  ...PropsFromDispatch,
}>;

export class Step3ReasonSpecificUsages extends React.Component<Props> {
  absenceReasonsSchema = split(this.props.schema, ["absenceReasons"]);

  componentDidMount() {
    if (this.props.onChange) {
      this.props.onChange(this.props.draft || {}, this.props.isValid);
    }
  }

  updateDraft = (data: Array<AbsenceReason>) => ({
    ...this.props.draft,
    absenceReasons: data,
  });

  handleChanges = (data: Array<AbsenceReason>) => {
    const updatedDraft = this.updateDraft(data);
    this.props.onUpdateDraft(updatedDraft);

    if (this.props.onChange) {
      this.props.onChange(updatedDraft, true);
    }
  };

  get data(): ?Array<AbsenceReason> {
    return this.props.draft ? this.props.draft.absenceReasons : null;
  }

  render() {
    return (
      <View className="gs-container">
        <div className="col-sm-12">
          {this.props.editable && this.props.schema ? (
            <ReasonSpecificUsageForm
              data={this.data}
              schema={this.absenceReasonsSchema}
              reasons={this.props.absenceReasons}
              onSubmit={this.handleChanges}
              onChange={this.handleChanges}
            />
          ) : null}
        </div>
      </View>
    );
  }
}

const mapStateToProps = (state, ownProps): PropsFromState => {
  return {
    draft: serviceSelectors.getDynamicQuestionDraft(state),
    absenceReasons: sharedSelectors.getAbsenceReasons(state),
    schema: serviceSelectors.getDynamicQuestionRevisionSchema(state),
    isValid: serviceSelectors.isDynamicQuestionDraftValid(state),
  };
};

const mapDispatchToProps: PropsFromDispatch = {
  onUpdateDraft: actionCreators.UpdateDynamicQuestionDraft,
};

export default compose(
  localize(),
  connect(mapStateToProps, mapDispatchToProps),
)(Step3ReasonSpecificUsages);
